import React from 'react';
import Layout from './layout/Layout';
import projectData from '../data/project-data.json';

export default ({ location, projectName }) => {
  const { name, asset, description, shortDescription } = projectData.find(
    project => project.name === projectName
  );

  return (
    <Layout location={location}>
      <section className="container mx-auto px-8">
        <div className="text-center">
          <div className="my-10">
            <h1 className="text-4xl font-bold">{name}</h1>
            <p className="text-xl font-light leading-relaxed">{shortDescription}</p>
          </div>
          <img src={asset} alt={name} className="leading-none mx-auto" />
          <div className="lg:mx-64">
            <p className="mt-8 text-xl font-light leading-relaxed">{description}</p>
          </div>
        </div>
      </section>
    </Layout>
  );
};
